export default __webpack_public_path__ + "static/media/financial-advisor-man-1x.77a94dac.png";